module.exports = __webpack_public_path__ + "img/lang_cur_icon.7fcc728.png";